import { v4 as uuidv4 } from 'uuid';
import EmployeeGridPluginSettings from './EmployeeGridPluginSettings';
import EmployeeGrid from './EmployeeGrid';

export const EmployeeTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Сотрудники',
        view: {
            content:    EmployeeGridPluginSettings 
                        ? <EmployeeGrid gridId={uuidv4()} plugin={EmployeeGridPluginSettings} />
                        : <p> Справочник не настроен </p>
        }
    }
}

export default EmployeeTab